var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.galleryAds.length > 0 && _vm.isMobile)?_c('ul',{staticClass:"gallery-ads--mobile"},_vm._l((_vm.galleryAdsSegment),function(ad){return _c('li',{staticClass:"gallery-ad--mobile",domProps:{"innerHTML":_vm._s(ad)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }